import { Breadcrumb, BreadcrumbIcon, BreadcrumbLink, BreadcrumbPage } from '@ads/components-react';
import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { SerieVideoForm } from '@/features/series-video-management';
import { PageHeader } from '@/shared/ui/organisms/PageHeader';

export const Route = createFileRoute('/_authenticated/series/$serieId/videos/create/')({
  component: SerieVideoCreatePage,
});

/** Página de criação de Vídeo. */
export function SerieVideoCreatePage() {
  const { t } = useTranslation('series');
  const { serieId: serieIdParam } = Route.useParams();
  const serieId = Number(serieIdParam);
  const navigate = useNavigate();

  const goBack = () =>
    void navigate({ to: '/series/$serieId/videos', params: { serieId: serieIdParam } });

  return (
    <div className="flex flex-col gap-mini">
      <PageHeader
        title={t('videos.form.createTitle')}
        breadcrumb={
          <Breadcrumb>
            <BreadcrumbLink>
              <Link to="/">
                <BreadcrumbIcon />
              </Link>
            </BreadcrumbLink>
            <BreadcrumbLink>
              <Link to="/series">{t('videos.breadcrumb.series')}</Link>
            </BreadcrumbLink>
            <BreadcrumbLink>
              <Link to="/series/$serieId/videos" params={{ serieId: serieIdParam }}>
                {t('videos.breadcrumb.videos')}
              </Link>
            </BreadcrumbLink>
            <BreadcrumbPage>{t('videos.form.createTitle')}</BreadcrumbPage>
          </Breadcrumb>
        }
      />

      <SerieVideoForm serieId={serieId} video={null} onSaved={goBack} onCancel={goBack} />
    </div>
  );
}
